import { render, staticRenderFns } from "./Itens.vue?vue&type=template&id=75e72123&"
import script from "./Itens.vue?vue&type=script&lang=js&"
export * from "./Itens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports